export namespace LPCoverFactory {
    export function preparedForFactory() {
        return {
            name: '',
            phoneSuffix: '+1',
            phone: '',
            salutations: '',
        };
    }
    export function addrFactory() {
        return {
            fullAddress: '4003 Woodbine Avenue, Markham, Ontario',
        };
    }
    export function preparedByFactory() {
        return {
            name: '',
            title: '',
            email: '',
            phone: '',
            website: '',
        };
    }
    export function agentBrokerageFactory() {
        return {
            name: '',
            addr: {},
            phone: '',
            website: '',
        };
    }
}
